import classNames from 'classnames/bind'
import PropTypes from 'prop-types'
import React from 'react'
import { Modal } from '@adc/ui-core'
import * as actions from './actions'
import reducer from './reducer'
import VerificationBox from './verificationBox'
import cls from './styles.scss'
const cx = classNames.bind(cls)

const VerificationModal = ({ className, elmId = 'auth', isOpen, ...rest }) => (
  <Modal
    className={className}
    closeIcon={false}
    closeOnDimmerClick={false}
    elmId={elmId}
    mobileTitleSkin='light'
    open={isOpen}
    size='small'
  >
    <Modal.Content>
      <div className={cx('verification-box-container')}>
        <VerificationBox elmId={elmId} {...rest} />
      </div>
    </Modal.Content>
  </Modal>
)

VerificationModal.propTypes = {
  className: PropTypes.string,
  elmId: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
}

VerificationModal.actions = actions
VerificationModal.reducer = reducer
VerificationModal.VerificationBox = VerificationBox

export default VerificationModal
